import { render } from "./LineChartH.vue?vue&type=template&id=1abac8fa&scoped=true"
import script from "./LineChartH.vue?vue&type=script&lang=ts"
export * from "./LineChartH.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1abac8fa"

export default script